import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";

import { CLIENT_TYPE_GOVERNMENT } from "../../../models/client";
import { getFieldErrors } from "../../../models/errors";
import { FieldErrors } from "../../form/FieldErrors";
import { useInvoiceFormContext } from "../context/InvoiceFormContext";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({
  icon,
  label,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
      marginTop: "16px",
    }}
  >
    <div
      style={{
        width: "4px",
        height: "18px",
        background: "#f9b115",
        borderRadius: "2px",
        marginRight: "10px",
        flexShrink: 0,
      }}
    />
    <i
      className={`fa ${icon} mr-2`}
      style={{ fontSize: "0.85rem", color: "#f9b115" }}
    ></i>
    <h6
      style={{
        margin: 0,
        fontWeight: 600,
        color: "var(--theme-muted)",
        fontSize: "0.78rem",
        textTransform: "uppercase",
        letterSpacing: "0.8px",
      }}
    >
      {label}
    </h6>
    <div
      style={{
        flex: 1,
        height: "1px",
        background: "var(--theme-divider)",
        marginLeft: "10px",
      }}
    />
  </div>
);

const FormLabel: React.FC<{
  required?: boolean;
  children: React.ReactNode;
}> = ({ required, children }) => (
  <CLabel
    className="mb-0"
    style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}
  >
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const InvoiceFormDNCPSection: React.FC = () => {
  const {
    client,
    invoiceRef,
    onDncpContractCodeChange,
    onDncpContractModalityChange,
    onDncpContractEntityChange,
    onDncpContractYearChange,
    onDncpContractSequenceChange,
    onDncpContractDateChange,
    errors,
  } = useInvoiceFormContext();

  if (client === null || client.type !== CLIENT_TYPE_GOVERNMENT) {
    return null;
  }

  const invoice = invoiceRef.current;

  return (
    <>
      <SectionDivider icon="fa-building-o" label="Datos de Contratación DNCP" />
      <div
        style={{
          background: "var(--theme-warning-surface)",
          border: "1px solid var(--theme-warning-border)",
          borderRadius: "8px",
          padding: "16px 20px",
          marginBottom: "16px",
        }}
      >
        <CFormGroup>
          <CRow className="align-items-center">
            <CCol md={2}>
              <FormLabel required>Código de Contratación:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Código de Contratación"
                onChange={onDncpContractCodeChange}
                defaultValue={invoice?.dncpContractCode || ""}
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("dncpContractCode", errors) as string[]}
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Modalidad:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Modalidad de Contratación"
                onChange={onDncpContractModalityChange}
                defaultValue={invoice?.dncpContractModality || ""}
              ></CInput>
              <FieldErrors
                errors={
                  getFieldErrors("dncpContractModality", errors) as string[]
                }
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Entidad:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Entidad de Contratación"
                onChange={onDncpContractEntityChange}
                defaultValue={invoice?.dncpContractEntity || ""}
              ></CInput>
              <FieldErrors
                errors={
                  getFieldErrors("dncpContractEntity", errors) as string[]
                }
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="mb-0">
          <CRow className="align-items-center">
            <CCol md={2}>
              <FormLabel required>Año:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Año de Contratación"
                onChange={onDncpContractYearChange}
                defaultValue={invoice?.dncpContractYear || ""}
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("dncpContractYear", errors) as string[]}
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Secuencia:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Secuencia de Contratación"
                onChange={onDncpContractSequenceChange}
                defaultValue={invoice?.dncpContractSequence || ""}
              ></CInput>
              <FieldErrors
                errors={
                  getFieldErrors("dncpContractSequence", errors) as string[]
                }
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Fecha:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="date"
                placeholder="Fecha de Contratación"
                onChange={onDncpContractDateChange}
                defaultValue={invoice?.dncpContractDate || ""}
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("dncpContractDate", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
      </div>
    </>
  );
};
